import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { EditDealerComponent } from './edit-dealer.component';
import { TrackingLogComponent } from './tracking-log.component';
import { ManageReturnMailerComponent } from './manage-returnmailer.component';
import { CdkDealerMappingComponent } from './cdk-dealer-mapping.component';
import { SubscribersListComponent } from './subscribers-list.component';
import { EditSubscriberComponent } from './edit-subscriber.component';
import { ClientSubscriptionDealersComponent } from './client-subscription-dealers.component';
const routes: Routes = [
    {
        path: '',
        data: { title: 'home' },
        children: []
    },
    {
        path: 'home',
        component: HomeComponent,
       
    },
    {
        path: 'edlr/:guid',
        component: EditDealerComponent,
       
    },
    {
        path: 'trlg/:id/:guid',
        component: TrackingLogComponent,
       
    },
    {
        path: 'endlr/:guid',
        component: EditDealerComponent,
       
    },
    {
        path: 'rm',
        component: ManageReturnMailerComponent,
       
    },
    
    {
        path: 'cdm',
        component: CdkDealerMappingComponent
       
    },
    {
        path: 'managesubscriptions',
        component: SubscribersListComponent
       
    },
    {
        path: 'dealer-list/:guid',
        component: ClientSubscriptionDealersComponent
       
    },
    {
        path: 'es/:guid',
        component: EditSubscriberComponent
       
    }



];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HomeRoutingModule { }
